import React, {useState,useMemo,useEffect} from 'react';
import { EuiButtonIcon, EuiCheckboxGroup, EuiFlexGrid, EuiFlexGroup, EuiFlexItem, EuiSwitch, EuiText } from "@elastic/eui";

export const ListadoAreasScreen = (props:any) =>{
    
    const {data, onSavePermisos} = props;

    const [soloDn, setSoloDn] = useState<any>({state:false,refresh:true});
    const [chkSelected, setChkSelected] = useState<any>({});

    useEffect(()=>{
            let newSatate = {...{state:false,refresh:true}}
            setSoloDn(newSatate)
    },[data])

    const chkAreas = useMemo(() =>{
        return data && data.areas.map((d:any)=>{
            return {
                id: `${d.codArea}`,
                label: `${d.area}`,
                disabled: !d.permisoArea
            }
        })
    },[data])

    const checkAll = () =>{
        let newChecksAll = {}
        data.areas.forEach((d:any) => {
            newChecksAll = {...newChecksAll, ...{[d.codArea]:true}}
        })
        setChkSelected(newChecksAll)
    }

    useEffect(()=>{
        let newSatate;
        if(data.permissions.length>0){
            if(data.permissions.filter((f:any)=> f.codArea!=='').length>0){
                let newChecks = {}
                data.permissions.forEach((d:any) => {
                    newChecks = {...newChecks, ...{[d.codArea]:true}}
                })
                newSatate = {...{state:false,refresh:false}}
                setSoloDn(newSatate)
                setChkSelected(newChecks)
            }else{
                newSatate = {...{state:true,refresh:true}}
                setSoloDn(newSatate)
            }
        }
        else{
            newSatate = {...{state:false,refresh:true}}
            setSoloDn(newSatate)
        }
    },[data])


    useEffect(()=>{
        if(soloDn.state===true){
            if(soloDn.refresh===true){checkAll()}
        }else{
            if(soloDn.refresh===true){onClearAreas()}
        }
    },[soloDn])

    const onChangeArea = (optionId:any) => {
        const newCheckboxIdToSelectedMap = {
          ...chkSelected,
          ...{
            [optionId]: !chkSelected[optionId],
          },
        };
        setChkSelected(newCheckboxIdToSelectedMap);
    };

    const onClearAreas = () =>{
        setChkSelected({})
    }

    const filterObject = useMemo(() => {
        return Object.keys(Object.fromEntries(Object.entries(chkSelected).filter(([key, val]) => val === true)))
    },[chkSelected])

    const getSeleccionados = ()=> {return filterObject.length}

    const getPermisos = useMemo(()=>{
        const areas = Object.keys(chkSelected).join();
        return (!soloDn.state && areas === '') ? null : {todaDn:soloDn.state, areas:(soloDn.state===true)?'':areas}
    },[soloDn,chkSelected])


    const disabledCheckAll = useMemo(()=> data && data.areas.filter((d:any)=> d.permisoArea===false).length>1,[data])

    const onChangeSoloDn = (oldState:any)=>{
        const newState = {...{state:!oldState,refresh:true}};
        setSoloDn(newState)
    }

    return (
        <EuiFlexGroup direction='column' style={{height:'100%'}}>
            <EuiFlexItem grow={false}>
                <EuiFlexGroup alignItems='center' style={{borderBottom: '1px solid #d3dae6'}}>
                    <EuiFlexItem grow={false}>
                        <EuiSwitch
                        className='sw-dn-permissions'
                        label="Toda DN/SG"
                        checked={soloDn.state}
                        disabled={disabledCheckAll}
                        onChange={(e) => {onChangeSoloDn(soloDn.state)}}
                        />
                    </EuiFlexItem>
                    <EuiFlexItem grow={false} style={{padding:'0.5rem',background: '#f3f3f3'}}>
                        <EuiFlexGroup alignItems='center'>
                            <EuiFlexItem grow={false} style={{background: '#006bb4',padding: '0.2rem 0.5rem',color: 'white',borderRadius: '20px'}}>
                                <EuiText>{`${getSeleccionados()} Áreas Seleccionadas`}</EuiText>
                            </EuiFlexItem>
                            <EuiFlexItem grow={false}>
                            <EuiButtonIcon style={{backgroundColor: '#f5d8d7',padding:'0.5rem',borderRadius: '30px'}} disabled={soloDn.state} size='m' 
                            title='Limpiar Selección' iconType='refresh' color='danger' onClick={onClearAreas}></EuiButtonIcon>
                            </EuiFlexItem>
                            <EuiFlexItem grow={false}>
                            <EuiButtonIcon style={{backgroundColor: '#c7e1f3',padding:'0.5rem',borderRadius: '30px'}} size='m' 
                            title='Guardar' iconType='save' color='primary' onClick={()=>{onSavePermisos(getPermisos)}}></EuiButtonIcon>
                            </EuiFlexItem>
                        </EuiFlexGroup>
                        
                        {/* <EuiButton disabled={soloDn} fill size='s' iconType='trash' color='danger' onClick={onClearAreas}></EuiButton> */}
                    </EuiFlexItem>
                </EuiFlexGroup>
                
            </EuiFlexItem>
            <EuiFlexItem>
                <EuiFlexGrid gutterSize='m' columns={2} direction="column">
                    <EuiCheckboxGroup
                        options={chkAreas}
                        idToSelectedMap={chkSelected}
                        onChange={(id) => onChangeArea(id)}
                        disabled={soloDn.state}
                    />
                </EuiFlexGrid>
            </EuiFlexItem>
        </EuiFlexGroup>
    )
}